module.exports = __webpack_public_path__ + "static/media/PM80.ee92e4b2.png";